import React from 'react';
import * as styles from './styles.scss';

const FormCouponGift = ({
    handleSubmit,
    handleChange,
    isLoading,
    name,
    data,
    translate,
}) => (
    <form onSubmit={handleSubmit} className={styles.cg}>
        <input
            type="text"
            name={name}
            onChange={handleChange}
            value={data}
            autoComplete="off"
        />
        <button
            disabled={isLoading}
        >
            {translate('Add')}
        </button>
    </form>
);

export default FormCouponGift;
